import { forkJoin, map, of, take } from "rxjs";
import type { Observable } from "rxjs";
import type { Router, UrlTree } from "@angular/router";

import { firstAllowedSidebarPath } from "@azm/core/constants/sidebar-item-permissions";
import type { AuthService } from "@azm/core/services/auth";
import type { SidebarService } from "@azm/core/services/sidebar";

export function guestHomePath(): string {
	return "/auth/login";
}

function withAudiencePrefix(path: string, auth: AuthService): string {
	if (auth.isInternalUser) return path;
	const role = auth.userRoleName;
	if (!role) return path;
	if (path === `/${role}` || path.startsWith(`/${role}/`)) return path;
	return `/${role}${path.startsWith("/") ? path : `/${path}`}`;
}

export function resolveInternalHomeUrl(auth: AuthService, sidebar: SidebarService, router: Router): Observable<UrlTree> {
	if (!auth.isAuthenticated) {
		return of(router.parseUrl(guestHomePath()));
	}

	return forkJoin({
		permissions: auth.getUserPermissions().pipe(take(1)),
		menu: sidebar.sidebarItems({ clearOnError: false }).pipe(take(1)),
	}).pipe(
		map(({ menu }) => {
			const first = firstAllowedSidebarPath(menu?.menuItems ?? [], auth);
			return router.parseUrl(first ? withAudiencePrefix(first, auth) : "/error/403");
		}),
	);
}
